import { render, staticRenderFns } from "./Annotation.vue?vue&type=template&id=7eb16eb1&scoped=true"
import script from "./Annotation.vue?vue&type=script&lang=js"
export * from "./Annotation.vue?vue&type=script&lang=js"
import style0 from "./Annotation.vue?vue&type=style&index=0&id=7eb16eb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb16eb1",
  null
  
)

export default component.exports